<template>
  <div
    id="customer-flyout"
    style="min-height: calc(100vh - 50px) !important; padding-bottom: 30px"
    class="address-flyout"
    :class="{
      'd-block': show_customer_address_details,
      'd-none': !show_customer_address_details,
    }"
  >
    <div class="heading">
      <b-row class="px-3" style="padding-top: 16px; padding-bottom: 16px">
        <b-col>
          <h5 class="mb-0 text-left">
            <template v-if="page == 'create'"
              >Add
              {{
                field.cus_addr_type == 1
                  ? "Billing Address"
                  : field.cus_addr_type == 2
                  ? "Shipping Address"
                  : "Additional Address"
              }}</template
            >
            <template v-else
              >Edit
              {{
                field.cus_addr_type == 1
                  ? "Billing Address"
                  : field.cus_addr_type == 2
                  ? "Shipping Address"
                  : "Additional Address"
              }}</template
            >
            <span class="float-right pr-2">
              <i
                class="la la-close cursor_pointer"
                @click="toggleCustomerAdditionalDetails()"
              ></i>
            </span>
          </h5>
        </b-col>
      </b-row>
    </div>
    <b-row class="pl-3 pr-4">
      <b-col>
        <b-form class="mt-3">
          <b-form-radio-group
            v-if="
              addresstype == 'form' &&
              (customeraddress.is_billing == 0 ||
                customeraddress.is_shipping == 0)
            "
            id="radio-group-2"
            v-model="field.cus_addr_type"
            name="radio-sub-component"
          >
            <b-form-radio
              value="1"
              v-if="customeraddress.is_billing == 0"
              :disabled="customeraddress.is_shipping == 1"
              >Billing</b-form-radio
            >
            <b-form-radio
              value="2"
              v-if="customeraddress.is_shipping == 0"
              :selected="customeraddress.is_billing == 1"
              :disabled="customeraddress.is_billing == 1"
              >Shipping</b-form-radio
            >
          </b-form-radio-group>
          <p
            class="py-2 mb-0 text-link fw-semi-bold cursor_pointer"
            @click="copyAddress()"
            v-if="
              field.cus_addr_type == '2' &&
              addresstype != 'form' &&
              this.copyadd != ''
            "
          >
            <i class="la la-copy la-lg mr-2"></i>
            <span class="btn-link">Shipping same as Billing Address</span>
          </p>
          <b-form-group
            label="Address Line 1"
            label-for="bill_addr_line_1"
            class="pt-3"
          >
            <b-form-input
              type="text"
              size="sm"
              v-model.trim="field.cus_addr_line_1"
              name="Address line 1"
              v-validate="'max:200'"
            ></b-form-input>
            <p
              class="fw-semi-bold text-danger"
              v-if="errors.has('Address line 1')"
            >
              {{ errors.first("Address line 1") }}
            </p>
          </b-form-group>
          <b-form-group label="Address Line 2" label-for="cus_addr_line_2">
            <b-form-input
              type="text"
              size="sm"
              v-model.trim="field.cus_addr_line_2"
              name="Address line 2"
              v-validate="'max:200'"
            ></b-form-input>
            <p
              class="fw-semi-bold text-danger"
              v-if="errors.has('Address line 2')"
            >
              {{ errors.first("Address line 2") }}
            </p>
          </b-form-group>
          <b-form-group label="State" label-for="cus_state">
            <v-select
              :clearable="false"
              name="State"
              id="search-select"
              v-model.trim="field.cus_state"
              size="sm"
              index="state_id"
              label="state_name"
              :options="$AppDetails.state_list"
            />
            <p class="fw-semi-bold text-danger" v-if="errors.has('State')">
              {{ errors.first("State") }}
            </p>
          </b-form-group>
          <b-form-group label="City" label-for="cus_city">
            <b-form-input
              type="text"
              size="sm"
              name="City"
              v-model.trim="field.cus_city"
              v-validate="'max:200'"
            ></b-form-input>
            <p class="fw-semi-bold text-danger" v-if="errors.has('City')">
              {{ errors.first("City") }}
            </p>
          </b-form-group>
          <b-form-group label="Country" label-for="cus_country">
            <v-select
              :clearable="false"
              name="Country"
              id="search-select"
              v-model.trim="field.cus_country"
              size="sm"
              index="country_id"
              label="country_name"
              :options="$AppDetails.country_list"
            />
            <p class="fw-semi-bold text-danger" v-if="errors.has('Country')">
              {{ errors.first("Country") }}
            </p>
          </b-form-group>
          <b-form-group
            label="Pincode"
            style="width: 150px"
            label-for="cus_pincode"
          >
            <b-form-input
              type="text"
              size="sm"
              label-for="cus_pincode"
              name="Pincode"
              v-model.trim="field.cus_pincode"
              v-validate="'max:10'"
            ></b-form-input>
            <p class="fw-semi-bold text-danger" v-if="errors.has('Pincode')">
              {{ errors.first("Pincode") }}
            </p>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row
      v-if="is_used > 0"
      :class="
        field.cus_addr_type == '2' &&
        addresstype != 'form' &&
        this.copyadd != ''
          ? 'pt-4 pb-4 pl-3 pr-3'
          : 'pb-4 pl-3 pr-3'
      "
    >
      <b-col class="mx-3">
        <input
          type="checkbox"
          :true-value="1"
          :false-value="0"
          v-model="is_update_tns"
          id="is_update"
        />
        Update address in this contact as well as in all the previous
        transactions like draft invoices, quotation, and creditnotes .
      </b-col>
    </b-row>
    <div>
      <b-button
        size="sm"
        variant="primary"
        class="float-right mr-4"
        @click="onSubmit()"
        :disabled="field.cus_addr_type == '' || submitted"
      >
        <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>
        {{ page == "create" ? "Save" : "Update" }}
      </b-button>
      <b-button
        size="sm"
        variant="light"
        class="float-right mr-3"
        @click="toggleCustomerAdditionalDetails()"
        >Cancel</b-button
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"; // get data set in the state in vuex
import vSelect from "vue-select"; // vue seatch select component
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
export default {
  props: [
    "field",
    "page",
    "addresstype",
    "customeraddress",
    "copyadd",
    "is_used",
  ],
  data() {
    return {
      submitted: false,
      customer_details: 0,
      is_update_tns: 0,
      show_customer_address_details: false,
    };
  },
  components: {
    vSelect,
  },
  methods: {
    copyAddress() {
      this.field.cus_addr_line_1 = this.copyadd.cus_addr_line_1;
      this.field.cus_addr_line_2 = this.copyadd.cus_addr_line_2;
      this.field.cus_state = this.copyadd.cus_state;
      this.field.cus_city = this.copyadd.cus_city;
      this.field.cus_country = this.copyadd.cus_country;
      this.field.cus_pincode = this.copyadd.cus_pincode;
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.page == "create" && this.addresstype == "form") {
            this.field.cus_addr_id =
              this.field.cus_addr_type == "1"
                ? this.customeraddress.cus_bill_addr_id
                : this.field.cus_addr_type == "2"
                ? this.customeraddress.cus_ship_addr_id
                : "";
          }
          let data = JSON.stringify({
            field: this.field,
            type: "customer",
            is_update_tns: this.is_update_tns,
          });
          this.submitted = true;
          this.$store.dispatch("customer/addresscreate", data).then(() => {
            var message;
            var type;
            if (this.status_code == 200) {
              // message =
              //   this.page == "create"
              //     ? "Address has been created successfully!"
              //     : "Address has been updated successfully!";
              message = this.message;
              type = "success";
              this.submitted = false;
              if (this.addresstype != "form") {
                this.$store.dispatch(
                  "customer/fetchViewList",
                  this.$route.params.id
                );
              }

              this.$emit("setcustomerAddAddress", this.customer_addr);
              this.show_customer_address_details = !this
                .show_customer_address_details;
            } else {
              this.submitted = false;
              message = this.message;
              type = "danger";
              this.$emit("setcustomerAddAddress", this.customer_addr);
            }
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: message,
              type: type,
              showCloseButton: true,
            });
          });
        }
      });
    },
    toggleCustomerAdditionalDetails() {
      this.show_customer_address_details = !this.show_customer_address_details;
      this.is_update_tns = 0;
      if (this.addresstype != "form") {
        this.$store.dispatch("customer/fetchViewList", this.$route.params.id);
      }
    },
  },
  mounted() {
    EventBus.$on(
      "toggleCustomerAdditionalDetails",
      this.toggleCustomerAdditionalDetails
    ); // to trigger the method from parentcomponent
  },

  computed: {
    ...mapState({
      code: (state) => state.customer.code,
      customer_addr: (state) => state.customer.customer_addr,
      message: (state) => state.customer.message,
      status_code: (state) => state.customer.status_code,
      status_message: (state) => state.customer.status_message,
      status_type: (state) => state.customer.status_type,
    }),
  },
};
</script>